import { useMutation } from "@tanstack/react-query";
import apiService from "../../api/axiosInstance";
import { useDispatch } from "react-redux";
import { setIsNewUser, setUser } from "./user.reducer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (loginData) => apiService.post("api/login", loginData),
    onSuccess: (data) => {
      console.log("Login successful:", data);
      dispatch(
        
        setUser({ user: data.data.data, token: data.data.data.jwtoken })
      );
      setTimeout(() => {
        const { user_name, parents_date_of_birth, profilephotos } =
          data.data.data;
        const isNameMissing = !user_name;
        const isDobMissing = !parents_date_of_birth;
        const isAvatarMissing = !profilephotos || profilephotos === "1";

        if (isNameMissing || isDobMissing || isAvatarMissing) {
          dispatch(setIsNewUser(true));
          navigate("/afterlogin", {
            state: {
              loginData: data.data.data,
              showNameTab: isNameMissing,
              showDobTab: isDobMissing,
              showAvatarTab: isAvatarMissing,
            },
            replace: true,
          });
        } else {
          navigate("/yearsdashboard");
        }
      }, 0);
    },
    onError: (error) => {
      toast.error(
        error.response?.data?.message || "Login failed. Please try again.",
        {
          ariaLabel: "Login Error",
          autoClose: 2000,
          theme: "colored",
          hideProgressBar: true,
          className: "font-mali",
        }
      );
    },
  });
};

export const useUpdateUser = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationKey: ["updateUser"],
    mutationFn: (updateData) => {
      var form_data = new FormData();

      for (var key in updateData) {
        form_data.append(key, updateData[key]);
      }
      return apiService.post("api/updatesignup", form_data);
    },
    onSuccess: (data) => {
      console.log("User updated successfully:", data);
      dispatch(
        setUser({ user: data.data.data, token: data.data.data.jwtoken })
      );
    },
    onError: (error) => {
      console.error(
        "User update failed:",
        error.response?.data?.message || error.message
      );
    },
  });
};

export default useLogin;
